export { default } from './errorBoundary';
